import GetListData from "./getListData";

export function isCallService(args) {
  args.loadingElement =
    typeof args.loadingElement == "undefined" ? null : args.loadingElement;
  try {
    // compensar.mostrarLoading(args.loadingElement)

    args.condition =
      typeof args.condition == "undefined" ? true : args.condition;
    args.showLogs =
      typeof args.condition == "undefined" ? false : args.showLogs;

    args.executeErrorCallback =
      args.executeErrorCallback == "undefined"
        ? false
        : args.executeErrorCallback;

    const urlPost = new ServicioProxyTransar(
      args.service,
      "ServicioTransar.svc"
    );
    const request = args.params;
    if (args.loadingElement) compensar.mostrarLoading(args.loadingElement);
    urlPost
      .getElements("POST", request)
      .then((response) => {
        const data = JSON.parse(response);
        if (data.ResponseCode === 200 && data.ResponseDetail === "Ok") {
          if (args.showLogs) {
            console.group("Respuesta del servicio");
            console.info("Respuesta:");
            console.info(data);
            console.groupEnd();
          }
          args.mainObject.setState({
            [args.changeState]: null,
            [args.changeState]: data.Result,
          });
          if (args.loadingElement) compensar.quitarLoading(args.loadingElement);
          args.condition ? args.executeCallback(data.Result) : null;
          // compensar.quitarLoading(args.loadingElement)
        } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
          // args.mainObject.getErrorMessage(data.ResponseDetail, "Cerrar", i18next.t("Modal.Bolean.True"), i18next.t("Modal.Bolean.False"))
          args.mainObject.setState({
            [args.modalMessage]: i18next.t("validaciones.errorServicio"),
            [args.error]: true,
          });
          args.executeErrorCallback ? args.executeErrorCallback() : null;
          if (args.loadingElement) compensar.quitarLoading(args.loadingElement);
          args.index ? args.executeCallback(data.Result) : null;

          // compensar.quitarLoading(args.loadingElement)
        } else if (data.ResponseCode === 430) {
          // args.mainObject.getErrorMessage(data.ResponseDetail, "Cancelar", i18next.t("Modal.Bolean.True"), i18next.t("Modal.Bolean.True"))
          // compensar.quitarLoading(args.loadingElement)
          if (args.loadingElement) compensar.quitarLoading(args.loadingElement);
        } else if (data.ResponseCode === 401) {
          getMessagesError(args);
          if (args.loadingElement) compensar.quitarLoading(args.loadingElement);
        }
      })
      .catch((error) => {
        console.warn(error);

        if (args.loadingElement) compensar.quitarLoading(args.loadingElement);
      });
  } catch (error) {
    console.group("Error en libreria de servicio");
    console.info("------------------------------");
    console.warn(error);
    console.info("------------------------------");
    console.groupEnd();
  }
}

function getMessagesError(args) {
  var inabilityTypes = [];
  let query = new GetListData();
  let servicesFilter = ["CSNombreText eq 'MensajePorDefectoErrorTransarProxy'"];
  let fieldImage = "";
  let requestType = null;
  let mensaje = "";
  let fieldsArrayServices = ["CSValorNote", "CSNombreText"];
  requestType = query
    .getListItems(
      "Configuraciones",
      200,
      servicesFilter,
      fieldsArrayServices,
      "",
      fieldImage
    )
    .then((Response) => {
      Response.forEach((result) => {
        mensaje = result.CSValorNote;
        args.mainObject.getErrorMessage(
          mensaje,
          "Cerrar",
          i18next.t("Modal.Bolean.True"),
          i18next.t("Modal.Bolean.False")
        );
        args.mainObject.setState({ error: true });
        compensar.quitarLoading(args.loadingElement);
      });
    });
}

/*
 * isCallService({
 *      loadingElement: '', // clase o id de elemento padre del loading
 *      service: '', // nombre del endpoint
 *      params: {}, // parametros par el servicio
 *      changeState: '', // variable de estado a cambiar
 *      executeCallback: function(val){}, // funcion para callback
 *      condition: true, //condicion para lanzar callback,
 *      showLogs: false,
 *      mainObject: this // obligatorio enviar el this,
 * })
 *
 */
